//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        data: {
            type: Object,
            default: () => ({
                couponname: '优惠券名称',
                couponprice: '100',
                minimum: '0',
                starttime: '开始时间',
                endtime: '结束时间',
                detail: '说明',
                isused: '0'
            })
        },
        width: {
            type: String,
            default: '350px'
        }
    },
    data () {
        return {

        }
    },
    computed: {
        mainColorStyle() {
            var switchObj = {
                '0': '#C0C4CC',
                '1': '#f18241'
            };
            return {
                backgroundColor: switchObj[this.data.isused]
            }
        }
    },
    methods: {

    },
    mounted: function() {

    }
}
